
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_1xk01_99",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_1xk01_133",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_1xk01_154",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_1xk01_157",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_1xk01_157",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_1xk01_160",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_1xk01_163",
  "sticky-cell": "awsui_sticky-cell_1spae_1xk01_166",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_1xk01_174",
  "has-selection": "awsui_has-selection_1spae_1xk01_174",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_1spae_1xk01_177",
  "resize-divider": "awsui_resize-divider_1spae_1xk01_181",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_1spae_1xk01_184",
  "sorting-icon": "awsui_sorting-icon_1spae_1xk01_199",
  "edit-icon": "awsui_edit-icon_1spae_1xk01_207",
  "header-cell-content": "awsui_header-cell-content_1spae_1xk01_213",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_1xk01_267",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_1xk01_267",
  "header-cell-text": "awsui_header-cell-text_1spae_1xk01_281",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_1xk01_285",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_1xk01_291",
  "header-cell-descending": "awsui_header-cell-descending_1spae_1xk01_292",
  "is-visual-refresh": "awsui_is-visual-refresh_1spae_1xk01_302",
  "has-striped-rows": "awsui_has-striped-rows_1spae_1xk01_313"
};
  